var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container",staticStyle:{"width":"calc(100% - 260px)"}},[_c('div',{staticClass:"copyright"},[_vm._v("\n      Desenvolvido por 3E Engenharia "+_vm._s(_vm.versionNumber)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f7afeda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Layout/ContentFooter.vue
// module id = yJ3N
// module chunks = 10